import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import {DashboardPinnedStatus} from "./models/Helper";

export default class HelperVuexModule extends AbacoVuexModule {
    @State() isFirstLogin!: boolean;
    @State({default: "doing"}) dashboardPinnedStatus!: DashboardPinnedStatus;
}
